export default {
  plural: 'Twin-ассеты',
  upload: 'Загрузить ассет',
  createTitle: 'Загрузить ассет',
  editTitle: 'Редактировать ассет',
  deleteTitle: 'Удалить ассет',
  deleteWarning: 'Вы уверены, что хотите удалить этот ассет?',
  deleteInUse:
    'Ассет нельзя удалить: он используется деталями. Сначала отвяжите его от деталей.',
  columns: {
    name: 'Название',
    assetType: 'Тип',
    company: 'Компания',
    mimeType: 'MIME-тип',
    createdAt: 'Создан'
  },
  profile: {
    title: 'Profile',
    parsedAt: 'Распознан',
    parsedNotSaved: 'Разобран локально, ещё не сохранён',
    isFrameOnly: 'Frame only',
    warnings: 'Предупреждения',
    mountCorrection: 'Ориентация крепления',
    mountCorrectionHint:
      'Применяется к коннекторам перед сохранением. Ножкам обычно нужен поворот 180° вокруг Z, ручкам +90° вокруг X.',
    applyMountCorrection: 'Применить ориентацию',
    sockets: 'Sockets',
    connectors: 'Connectors',
    zones: 'Zones',
    materials: 'Materials',
    reparse: 'Перепарсить',
    parse: 'Распознать',
    noProfileYet: 'Профиль ещё не создан'
  },
  overrides: {
    open: 'Переопределения',
    title: 'Переопределения профиля',
    meshesTitle: 'Меши',
    meshZoneColumn: 'Зона',
    noZone: '—',
    customZone: 'Своя зона…',
    customZoneHint:
      'Создайте zone template с этим кодом, чтобы он появился в списке',
    nodesTitle: 'Узлы',
    markColumn: 'Метка',
    group: 'Группа',
    position: 'Позиция',
    kind: 'Вид',
    save: 'Сохранить',
    reuploadNote:
      'Переопределения хранятся на ассете и переприменяются при Reparse и перезаливке GLB; ссылки на переименованные меши/узлы превращаются в предупреждения профиля.',
    loadError: 'Не удалось загрузить GLB для редактирования'
  }
};
